import React from 'react';
import { Phone, MessageCircle, Sparkles } from 'lucide-react';
import { BRAND } from '../data/mock';
import { useQuote } from '../context/QuoteContext';

const FloatingButtons = () => {
  const { openQuote } = useQuote();
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <button
        type="button"
        onClick={() => openQuote({ source: 'floating' })}
        aria-label="Request Quote"
        className="group relative w-14 h-14 rounded-full bg-white text-pink-brand border border-pink-200 shadow-floating flex items-center justify-center transition-transform hover:scale-110"
        data-testid="floating-request-quote-button"
      >
        <Sparkles className="w-6 h-6" />
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-stone-900 text-white text-xs px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">Get a Quote</span>
      </button>
      <a
        href={`https://wa.me/${BRAND.phoneRaw}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="group relative w-14 h-14 rounded-full bg-pink-brand shadow-pink-glow flex items-center justify-center transition-transform hover:scale-110"
        data-testid="floating-whatsapp-link"
      >
        <span className="absolute inset-0 rounded-full bg-pink-brand animate-soft-ping" />
        <MessageCircle className="w-6 h-6 text-white relative" />
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-stone-900 text-white text-xs px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">WhatsApp</span>
      </a>
      <a
        href={`tel:${BRAND.phone}`}
        aria-label="Call"
        className="group relative w-14 h-14 rounded-full bg-pink-brand shadow-pink-glow flex items-center justify-center transition-transform hover:scale-110"
        data-testid="floating-call-link"
      >
        <Phone className="w-6 h-6 text-white relative" />
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-stone-900 text-white text-xs px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">Call Now</span>
      </a>
    </div>
  );
};

export default FloatingButtons;
